import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    marginTop: 8,
    padding: '12px 4px 12px 8px',
    borderRadius: 16,
    display: 'flex',
    flex: 1,
    boxShadow: '0 2px 9px 0 rgb(0 0 0 / 19%)',
    flexDirection: 'column',
    width: '100%'
    // [theme.breakpoints.down('md')]: {
    //   transform: 'scale(0.9)'
    // }
  },
  topPart: {
    paddingTop: 5,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 8,
    width: '100%',
    alignItems: 'center'
  },
  middlePart: {
    display: 'grid',
    gridTemplateColumns: '20fr 1fr 20fr'
  },
  separator: {
    width: 1,
    height: 57,
    marginTop: 5,
    borderLeft: 'dashed 1px #ababab',
    paddingRight: 7,
    marginRight: 10
  },
  searchButtonContianer: {
    position: 'absolute',
    width: '100%',
    maxWidth: 200,
    right: 0,
    height: 'calc(100% + 0px)'
  },
  searchButton: {
    borderRadius: 8,
    width: '98%',
    height: 48,
    fontSize: 23
  },
  btnBase: { width: '100%' },
  dateModal: {
    top: -12,
    right: 0,
    position: 'absolute',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    maxWidth: 950,
    zIndex: 1,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    borderRadius: 9
  },
  nightContainer: {
    height: 'calc(100% + 30px)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: 67,
    paddingTop: 50,
    paddingBottom: 12,
    marginBottom: 20,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    borderRadius: 9
  },
  guestModal: {
    top: 0,
    right: 75,
    position: 'absolute',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: '17px 51px 17px 53px',
    maxHeight: 460,
    width: 371,
    zIndex: 1000,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    borderRadius: 9
  },
  searchIcon: {
    fontSize: '24px'
  },
  btnText: { color: theme.palette.primary.contrastText },
  divider: { margin: '16px 0', backgroundColor: theme.palette.grey[500] },
  verticalDivider: { height: '100%', backgroundColor: theme.palette.grey[500] },
  btnContainer: { marginTop: '8px' }
}))
export default useStyles
